import React from 'react'
import { Alert, Button, InfoCircleFilled, RedoOutlined } from 'gokwik-ui-kit'

type AlertType = 'error' | 'warning' | 'info' | 'success'

interface GenericAlertProps {
    type?: AlertType
    showIcon?: boolean
    icon?: React.ReactNode
    children: React.ReactNode
    showCTA?: boolean
    ctaText?: string
    ctaIcon?: React.ReactNode
    onClickCTA?: () => void
    className?: string
}

const typeToColorMap = {
    error: {
        iconColor: 'text-red-500',
        textColor: 'text-red-800',
        borderColor: 'border-l-red-500',
    },
    warning: {
        iconColor: 'text-yellow-500',
        textColor: 'text-yellow-800',
        borderColor: 'border-l-yellow-500',
    },
    info: {
        iconColor: 'text-blue-500',
        textColor: 'text-blue-800',
        borderColor: 'border-l-blue-500',
    },
    success: {
        iconColor: 'text-green-500',
        textColor: 'text-green-800',
        borderColor: 'border-l-green-500',
    },
}

const GenericAlert: React.FC<GenericAlertProps> = ({
    type = 'info',
    showIcon,
    icon,
    children,
    showCTA = false,
    ctaText = '',
    ctaIcon,
    onClickCTA,
    className = '',
}) => {
    const current = typeToColorMap[type]

    return (
        <Alert
            type={type}
            className={`m-4 p-0 border-y-0 border-r-0 rounded-sm border-l-4 ${current.borderColor} ${className}`}
            description={
                <div className='flex px-4 py-2 gap-2 items-center'>
                    {showIcon && (
                        <div className='flex justify-center items-center text-3xl'>
                            {icon || <InfoCircleFilled className={current.iconColor} />}
                        </div>
                    )}
                    <div
                        className={`flex-1 ${current.textColor} justify-start items-start`}
                        style={{ marginLeft: type === 'error' ? '-6px' : '0px' }}
                    >
                        {children}
                    </div>
                    {showCTA && (
                        <div className='flex justify-center items-center'>
                            <Button variant='primary' onClick={onClickCTA}>
                                {ctaIcon || <RedoOutlined className='mr-2' />}
                                {ctaText}
                            </Button>
                        </div>
                    )}
                </div>
            }
        />
    )
}

export default GenericAlert
